module.exports = __webpack_public_path__ + "102c74944a2d04e0ba6016e13b4620a5.jpg";